var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.doughnutTotalsPersonsTypes).length > 0)?_c('div',[_c('doughnut-chart',{attrs:{"id":"doughnut-chart-size","height":_vm.height,"chart-data":_vm.doughnutTotalsPersonsTypes.chartData,"extra-options":_vm.doughnutTotalsPersonsTypes.extraOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }